const TopBarDropDownConstantsAr = {
  TopBarDropDownManageProfile: 'إدارة الملف الشخصي',
  ViewAllNotificationsLinkText: 'عرض جميع الإشعارات',
  NoUnreadNotificationsMessage: 'لا يوجد إشعارات جديده'
};

export default TopBarDropDownConstantsAr;
